import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-listing-three',
  templateUrl: './listing-three.component.html',
  styleUrls: ['./listing-three.component.scss']
})
export class ListingThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
